import pinLikeSurfaceAction from './utils/pinLikeSurfaceAction';
import { createLazyComponent, LazyModule } from 'owa-bundling';
import { lazyGetTrustedSendersAndDomains } from 'owa-trusted-senders';
import { runAfterInitialRender } from 'owa-delayed-initialization';
import { default as preparePopoutDataForReadingPane } from './utils/preparePopoutDataForReadingPane';
import { getBrandsSubscriptionsService } from 'owa-brands-subscription';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
var lazyModule = new LazyModule(function () {
    return System.import(
    /* webpackChunkName: "ReadingPane", webpackPrefetch: true */ './lazyIndex');
});
// Export delay loaded components
export var ConversationReadingPane = createLazyComponent(lazyModule, function (m) { return m.ConversationReadingPane; });
export var ReadingPane = createLazyComponent(lazyModule, function (m) { return m.ReadingPane; });
export var ItemReadingPane = createLazyComponent(lazyModule, function (m) { return m.ItemReadingPane; });
export var SecondaryReadingPaneTabCommandingBar = createLazyComponent(lazyModule, function (m) { return m.SecondaryReadingPaneTabCommandingBar; });
runAfterInitialRender(function () {
    if (isMailFeatureEnabled('rp-infoBarBrandSubscription')) {
        //load Brand Subscriptions cache
        getBrandsSubscriptionsService();
    }
    lazyGetTrustedSendersAndDomains.importAndExecute;
    pinLikeSurfaceAction();
});
export { preparePopoutDataForReadingPane, };
//# sourceMappingURL=index.js.map